const FEServer = 'https://guahao.dtgh91.com/#/pages/' //配置线上的域名,分享调用
// const FEServer = 'http://192.168.1.46:8080/#/pages/' //配置线上的域名,分享调用

export default{
    FEServer:FEServer
}